<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Finance COD RECO Report</strong>
          </div>
          <div>
            <b-row class="mt-3">
              <b-col cols="4">
                <b-form-group label="From Date : "  :label-cols="3" >
                  <v-date-picker
                    mode="single"
                    input-class="dateInput"
                    :available-dates="{ start: null, end: new Date() }"
                    v-model="fromDate"
                  >
                  </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="To Date : "  :label-cols="3" >
                  <v-date-picker
                    mode="single"
                    input-class="dateInput"
                    :available-dates="{ start: null, end: new Date() }"
                    v-model="toDate"
                  >
                  </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Hub : "  :label-cols="2" >
                <b-form-select class="form-control input" v-model="destinationhubid">
                    <option :value="null"  >--Select--</option>
                        <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                    </b-form-select>          
                </b-form-group> 
              </b-col>
              <b-col cols="2" style="text-align:left;">
                <b-form-group>
                    <button class="btn btn-primary" @click="getFinanceCODListing(1)"> Search </button>                       
                    <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
                </b-form-group>
              </b-col>
              <b-col cols="2" style="text-align:right;">
                <b-form-group>
                  <button class="btn btn-primary" @click="financeCOD" :disabled="totalRows==0">Export </button>                       
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="my-2"> 
              <b-col sm="12" class="text-right">
                <b-col sm="12">  
                  <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
                </b-col>
              </b-col> 

              <b-col sm="12">
                <b-table 
                  show-empty 
                  stacked="md"
                  :busy="isBusy"
                  :items="items"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :bordered="bordered"
                >
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div> 

                </b-table>
              </b-col>

              <b-col sm="12" class="my-1 " v-if="this.totalRows > 10">
                <paginate 
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :current-page="currentPage"
                >
                </paginate>
              </b-col>      
            </b-row>
        </div>
        </b-card>
      </b-col>
      </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
  export default{
    data:function(){
      return{
        name:'financeCODReport',
        isBusy: false,
        items: [],
        fields: [
          {key:'hub_name',label:'Hub Name'},
          {key:'created_date',label:'Date'},
          {key:'opening_bls',label:'Opening Balance'},
          {key:'cod_collection',label:'COD Collection'},
          {key:'approved_expenses',label:'Approved Expense'},
          {key:'pending_expenses',label:'Pending Expense'},
          {key:'rejected_expenses',label:'Rejected Expense'},
          {key:'pending_cod_in_hub_bls',label:'Pending COD in HUB Balance'},
          {key:'amount_deposit', label: "Amount Deposit" },
          {key:'bls_in_hub', label: "Balance in HUB" },        
        ],

        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        searching:'',
        noofpages:'',
        pageNum:1,

        toDate:new Date(),
        fromDate:new Date(),

        destinationhubid:null,
        hublist:[],

        downloadreport:'',
      }
    },
    created: function(){
        this.getHublist();
        this.getFinanceCODListing(1);
    },
    methods:{
        getHublist: function() {
            //this.lodershow=true;
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            console.log("userInfo",userInfo)
            var currenthub=userInfo.pickuplocationmasterid;
            var hubobj={
              hub_id:currenthub.toString()
            }

            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
            .then(result => {
                //this.lodershow=false;
                if(result.body.returnmsg=='Successful'){
                this.hublist = result.body.returnvalue;
                }
                //console.log('mukesh',this.hublist);
            })
            .catch(ex => {
                console.log('error', ex)
            });
        },

        getFinanceCODListing:function(pageNo){
            this.isBusy = true;

            if(this.fromDate > this.toDate){
                console.log('this.fromDate--->',this.fromDate);
                console.log('this.toDate--->',this.toDate);
                this.$fire({
                    text: "From date must be smaller than To date",
                    type: "warning",
                    timer: 30000
                }); 
            }
            else{
                const Obj ={
                    fromdate: this.formatDate(this.fromDate),
                    todate: this.formatDate(this.toDate),
                    hub_id: this.destinationhubid,
                    page_no: pageNo ? pageNo :1,
                    limit: 10,
                    downloadAsCSV: ""
                }

                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCODFinaceRecoReportList`,Obj)
                .then(result=>{
                    this.isBusy = false;
                    if(result.body.returnmsg === 'Successful'){
                        this.items = result.body.returnvalue;
                        this.totalRows = result.body.total_records;
                        this.noofpages=parseInt(this.totalRows)/10;
                        this.noofpages=Math.ceil( this.noofpages);
                    }
                    else{
                        this.items = [];
                        this.totalRows = 0;
                    }
                })
                .catch(ex =>{
                    console.log('error',ex)
                })
            }
        },

        financeCOD(){
            const Obj={
                fromdate: this.formatDate(this.fromDate),
                todate: this.formatDate(this.toDate),
                hub_id: this.destinationhubid,
                page_no: 1,
                limit: 10,
                downloadAsCSV:"true"
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCODFinaceRecoReportList`,Obj)
            .then(result=>{

            if(result.body){
                this.downloadReport(result.body)
            }
            else{
                this.downloadreport='';
            }
            })
            .catch(ex=>{
                console.log('error',ex)
            })
        },

        downloadReport(data){
            const csvData = data
            console.log("Data for download---> ",csvData);
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
            anchor.download = 'FinanceCODReport.csv';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        },

        clickCallback(pageNo){
          console.log("Current_page--->",this.currentPage)
          this.getFinanceCODListing(pageNo)
        },

        refresh(){
            this.fromDate = new Date();
            this.toDate = new Date();
            this.destinationhubid = null;
            this.getFinanceCODListing(1);
        },

        formatDate: function(date) {
            var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");
        },
    }
  }
</script>

<style>

</style>